import * as React from 'react';
import { SVGProps } from 'react';
const TimePickerArrowTopMobileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#569DE5"
      d="m10.565.438 8.348 8.348c.238.238.37.555.37.894 0 .34-.132.656-.37.895l-.758.758a1.28 1.28 0 0 1-1.8 0l-4.88-4.87v15.472c0 .697-.546 1.249-1.244 1.249H9.159c-.698 0-1.299-.552-1.299-1.25V6.409l-4.908 4.924c-.238.239-.547.37-.886.37-.338 0-.652-.131-.89-.37l-.756-.757a1.255 1.255 0 0 1-.368-.895c0-.339.132-.656.37-.895L8.77.438c.239-.24.558-.37.897-.37.34 0 .66.13.898.37Z"
    />
  </svg>
);
export default TimePickerArrowTopMobileIcon;
